var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
var NewCaseComponent = /** @class */ (function () {
    function NewCaseComponent(fb, apiService, util, activatedRoute, router) {
        this.fb = fb;
        this.apiService = apiService;
        this.util = util;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.isPopupMode = false;
        this.isAddMode = false;
        this.isNewCaseForContactId = false;
        this.isViewMode = false;
        this.isShowAnswerLink = false;
        this.isEndCase = false;
        this.isNewCaseForChatbot = false;
        this.kmCriteria = "";
        this.showingKBList = [];
        this.role = {};
        this.submitted = false;
        this.caseSubTypeList = [];
        this.caseSubTypeDetailList = [];
        this.createBy = "";
        this.modifiedBy = "";
        this.id = "";
        this.guid = "";
        this.isEditMode = false;
        this.agentList = [];
        this.userIdReceive = "";
        this.userList = [];
        this.contactList = [];
        this.forwardRemark = "";
        this.submittedForward = false;
        this.dpa_pdpa_flag = false;
        this.isRemarkRequired = false;
        this.isResolvedRequired = false;
        this.form = this.fb.group({
            contactid: "",
            dpa_contacttype: "",
            firstname: ['', Validators.required],
            lastname: "",
            dpa_idcard: "",
            dpa_passport: "",
            birthdate: "",
            dpa_companyname: "",
            dpa_registrationdate: "",
            dpa_authorizedperson: "",
            dpa_authorizedperson_idcard: "",
            dpa_authorizedperson_telephone: "",
            telephone1: ['', Validators.required],
            dpa_otherphone: "",
            emailaddress1: ['', this.emailValidator],
            dpa_contact_homeno: "",
            dpa_contact_building: "",
            dpa_contact_moo: "",
            dpa_contact_street: "",
            dpa_contact_subdistict: "",
            dpa_contact_distict: "",
            dpa_contact_province: "",
            dpa_contact_postcode: "",
            dpa_contact_country: "",
            dpa_registration_homeno: "",
            dpa_registration_building: "",
            dpa_registration_moo: "",
            dpa_registration_street: "",
            dpa_registration_subdistict: "",
            dpa_registration_distict: "",
            dpa_registration_province: "",
            dpa_registration_postcode: "",
            dpa_registration_country: "",
            dpa_dopaflag: "",
            dpa_ndidflag: "",
            dpa_agentbankflag: "",
            dpa_verifydate: "",
            dpa_facebookflag: "",
            dpa_googleflag: "",
            dpa_lineflag: "",
            statusreason: "",
            incidentid: "",
            ticketnumber: "",
            title: "",
            customerid: "",
            dpa_casetypeid: ['', Validators.required],
            dpa_casesubtypeid: ['', Validators.required],
            dpa_casesubtypedetailid: ['', Validators.required],
            dpa_casechannelid: new FormControl({ value: '' }, Validators.required),
            dpa_caseseverityid: ['', Validators.required],
            description: ['', Validators.required],
            dpa_remark: "",
            dpa_casestatusid: ['', Validators.required],
            dpa_resolveddate: "",
            dpa_createdby: "",
            dpa_modifiedby: "",
            dpa_caseowner: "",
            dpa_owningteamid: "",
            dpa_resolveby: "",
            dpa_assignby: "",
            dpa_resolution: "",
            callcenterflag: true,
            dpa_pdpa_flag: false
        });
    }
    NewCaseComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        this.util.ShowWaiting(true);
                        this.util.InitValidation();
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        this.role = JSON.parse(this.cookieData.role);
                        this.myTeams = JSON.parse(this.cookieData.teams);
                        //this.role = JSON.parse(localStorage.getItem("role"))
                        this.id = this.activatedRoute.snapshot.paramMap.get('id');
                        url = this.activatedRoute.snapshot['_routerState'].url;
                        if (url.includes("newCaseForContact")) {
                            this.isNewCaseForContactId = true;
                        }
                        else if (url.includes("caseDetail") || (this.guid != null && this.guid.length > 0)) {
                            this.isViewMode = true;
                        }
                        else {
                            if (url.includes("newCaseChatbot")) {
                                this.isNewCaseForChatbot = true;
                            }
                            else {
                                this.isAddMode = true;
                            }
                        }
                        return [4 /*yield*/, this.InitDropdown()];
                    case 1:
                        _a.sent();
                        $("#userIdReceive").on("change", function () {
                            thisTs.userIdReceive = $("#userIdReceive").find('option:selected').val();
                        });
                        $("#ra2")[0].checked = true;
                        $("#ra1").on("click", function () {
                            if (!$(this).checked) {
                                $("#ra1")[0].checked = true;
                                $("#ra2")[0].checked = false;
                            }
                        });
                        $("#ra2").on("click", function () {
                            if (!$(this).checked) {
                                $("#ra1")[0].checked = false;
                                $("#ra2")[0].checked = true;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    NewCaseComponent.prototype.InitDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.isNewCaseForContactId) {
                    Observable.forkJoin(this.apiService.get("master", "caseChannel"), this.apiService.get("master", "caseStatus"), this.apiService.get("master", "caseSeverity"), this.apiService.get("master", "caseType"), this.apiService.get("master", "caseSubType"), this.apiService.get("master", "caseSubTypeDetail"), this.apiService.get("master", "callcenterTeam"), this.apiService.get("crmservice", "contact", "contactid=" + this.id)).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                        var tmp, tmpSubTypeDetail, contactTmps, para, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    this.caseChannelList = data[0];
                                    tmp = data[1];
                                    this.caseSeverityList = data[2];
                                    this.caseTypeList = data[3];
                                    this.subTypeTmpList = data[4];
                                    tmpSubTypeDetail = data[5];
                                    this.teamList = data[6];
                                    contactTmps = data[7];
                                    para = "";
                                    this.teamList.forEach(function (t) {
                                        if (para != "") {
                                            para += "&";
                                        }
                                        para += "callcenterteam=" + t.dpa_callcenterteamid;
                                    });
                                    _a = this;
                                    return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", para)];
                                case 1:
                                    _a.agentList = _b.sent();
                                    this.caseStatusList = tmp.filter(function (t) {
                                        return t.dpa_isdisplay;
                                    });
                                    this.subTypeDetailTmpList = tmpSubTypeDetail.filter(function (s) {
                                        return !s.dpa_issendemail;
                                    });
                                    this.contactList = contactTmps[0];
                                    return [4 /*yield*/, this.initAddModeForContact(contactTmps[0])];
                                case 2:
                                    _b.sent();
                                    this.util.ShowWaiting(false);
                                    return [2 /*return*/];
                            }
                        });
                    }); }, function (err) { return console.error(err); });
                }
                else if (this.isViewMode) {
                    Observable.forkJoin(this.apiService.get("master", "caseChannel"), this.apiService.get("master", "caseStatus"), this.apiService.get("master", "caseSeverity"), this.apiService.get("master", "caseType"), this.apiService.get("master", "caseSubType"), this.apiService.get("master", "caseSubTypeDetail"), this.apiService.get("master", "callcenterTeam"), this.apiService.get("crmservice", "caseIncident", (this.guid != null && this.guid.length > 0) ? "caseid=" + this.guid : "caseno=" + this.id)).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                        var tmp, tmpSubTypeDetail, caseInfo, para, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    this.caseChannelList = data[0];
                                    tmp = data[1];
                                    this.caseSeverityList = data[2];
                                    this.caseTypeList = data[3];
                                    this.subTypeTmpList = data[4];
                                    tmpSubTypeDetail = data[5];
                                    this.teamList = data[6];
                                    caseInfo = data[7];
                                    para = "";
                                    this.teamList.forEach(function (t) {
                                        if (para != "") {
                                            para += "&";
                                        }
                                        para += "callcenterteam=" + t.dpa_callcenterteamid;
                                    });
                                    _a = this;
                                    return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", para)];
                                case 1:
                                    _a.agentList = _b.sent();
                                    this.caseStatusList = tmp.filter(function (t) {
                                        return t.dpa_isdisplay;
                                    });
                                    this.subTypeDetailTmpList = tmpSubTypeDetail.filter(function (s) {
                                        return !s.dpa_issendemail;
                                    });
                                    return [4 /*yield*/, this.initViewMode(caseInfo)];
                                case 2:
                                    _b.sent();
                                    this.util.ShowWaiting(false);
                                    return [2 /*return*/];
                            }
                        });
                    }); }, function (err) { return console.error(err); });
                }
                else if (this.isNewCaseForChatbot || this.isAddMode) {
                    Observable.forkJoin(this.apiService.get("master", "caseChannel"), this.apiService.get("master", "caseStatus"), this.apiService.get("master", "caseSeverity"), this.apiService.get("master", "caseType"), this.apiService.get("master", "caseSubType"), this.apiService.get("master", "caseSubTypeDetail"), this.apiService.get("master", "callcenterTeam")).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                        var tmp, tmpSubTypeDetail, para, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    this.caseChannelList = data[0];
                                    tmp = data[1];
                                    this.caseSeverityList = data[2];
                                    this.caseTypeList = data[3];
                                    this.subTypeTmpList = data[4];
                                    tmpSubTypeDetail = data[5];
                                    this.teamList = data[6];
                                    para = "";
                                    this.teamList.forEach(function (t) {
                                        if (para != "") {
                                            para += "&";
                                        }
                                        para += "callcenterteam=" + t.dpa_callcenterteamid;
                                    });
                                    _a = this;
                                    return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", para)];
                                case 1:
                                    _a.agentList = _b.sent();
                                    this.caseStatusList = tmp.filter(function (t) {
                                        return t.dpa_isdisplay;
                                    });
                                    this.subTypeDetailTmpList = tmpSubTypeDetail.filter(function (s) {
                                        return !s.dpa_issendemail;
                                    });
                                    return [4 /*yield*/, this.initAddMode()];
                                case 2:
                                    _b.sent();
                                    this.util.ShowWaiting(false);
                                    return [2 /*return*/];
                            }
                        });
                    }); }, function (err) { return console.error(err); });
                }
                return [2 /*return*/];
            });
        });
    };
    NewCaseComponent.prototype.createCase = function (callByNull) {
        if (callByNull === void 0) { callByNull = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var caseId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.post("crmservice", "caseIncident", this.form.getRawValue(), callByNull).then(function (res) {
                            if (_this.util.isSuccessResponse(res)) {
                                if (res.incidentid != null && res.incidentid != "") {
                                    caseId = res.incidentid;
                                }
                                else {
                                    _this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ");
                                    return null;
                                }
                            }
                            else {
                                _this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ");
                                return null;
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, caseId];
                }
            });
        });
    };
    NewCaseComponent.prototype.createContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var caseId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.form.controls["callcenterflag"].setValue(true);
                        return [4 /*yield*/, this.apiService.post("crmservice", "contact", this.form.getRawValue()).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.util.isSuccessResponse(res)) return [3 /*break*/, 4];
                                            if (!(res.contactid != null && res.contactid != "")) return [3 /*break*/, 2];
                                            this.form.controls["customerid"].setValue(res.contactid);
                                            this.form.controls["contactid"].setValue(res.contactid);
                                            this.form.controls["dpa_casechannelid"].setValue(this.dpa_casechannelid);
                                            return [4 /*yield*/, this.apiService.post("crmservice", "caseIncident", this.form.getRawValue(), true).then(function (res) {
                                                    if (_this.util.isSuccessResponse(res)) {
                                                        if (res.incidentid != null && res.incidentid != "") {
                                                            caseId = res.incidentid;
                                                        }
                                                        else {
                                                            caseId = null;
                                                        }
                                                    }
                                                    else {
                                                        caseId = null;
                                                    }
                                                })];
                                        case 1:
                                            _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            caseId = null;
                                            _a.label = 3;
                                        case 3: return [3 /*break*/, 5];
                                        case 4:
                                            caseId = null;
                                            _a.label = 5;
                                        case 5: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, caseId];
                }
            });
        });
    };
    NewCaseComponent.prototype.updateCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.put("crmservice", "caseIncident/" + this.form.get("incidentid").value, this.form.getRawValue())];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            return [2 /*return*/, true];
                        }
                        else {
                            this.util.ErrorDialog("แก้ไข Case ไม่สำเร็จ");
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NewCaseComponent.prototype.updateContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.put("crmservice", "contact/" + this.form.get("contactid").value, this.form.getRawValue())];
                    case 1:
                        res = _a.sent();
                        if (!this.util.isSuccessResponse(res)) {
                            this.util.ErrorDialog("แก้ไข Contact ไม่สำเร็จ");
                            return [2 /*return*/, false];
                        }
                        else {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NewCaseComponent.prototype.forward = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var caseStatus, caseForwardSubTypeDetail_1, matchTeam, matchUser, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!((this.isRemarkRequired && this.formControl["dpa_remark"].value.trim().length == 0) ||
                            (this.isResolvedRequired && this.formControl["dpa_resolution"].value.trim().length == 0))) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1:
                        if (!this.form.valid) return [3 /*break*/, 10];
                        caseStatus = this.caseStatusList.filter(function (s) {
                            return s.dpa_casestatusid == _this.formControl["dpa_casestatusid"].value;
                        });
                        if (!(caseStatus != null && caseStatus.length > 0 && (caseStatus[0].dpa_name.toLowerCase() == "new" || caseStatus[0].dpa_name.toLowerCase() == "inprogress"))) return [3 /*break*/, 9];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 6, , 8]);
                        caseForwardSubTypeDetail_1 = this.subTypeDetailTmpList.filter(function (st) {
                            return st.dpa_casesubtypedetailid == _this.formControl["dpa_casesubtypedetailid"].value;
                        });
                        matchTeam = this.teamList.filter(function (t) {
                            return t.dpa_callcenterteamid == caseForwardSubTypeDetail_1[0].dpa_teamownerid;
                        });
                        if (!(matchTeam != null && matchTeam.length > 0)) return [3 /*break*/, 4];
                        this.forwardTeam = caseForwardSubTypeDetail_1[0].dpa_teamownerid;
                        return [4 /*yield*/, this.onForwardTeamChange()];
                    case 3:
                        _a.sent();
                        matchUser = this.userList.filter(function (u) {
                            return u.dpa_customwebuserid == caseForwardSubTypeDetail_1[0].dpa_caseownerid;
                        });
                        if (matchUser != null && matchUser.length > 0) {
                            this.userIdReceive = caseForwardSubTypeDetail_1[0].dpa_caseownerid;
                        }
                        else {
                            this.userIdReceive = "";
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        this.forwardTeam = "";
                        _a.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1 = _a.sent();
                        console.log("ไม่สามารถกำหนดค่าเริ่มต้นได้");
                        this.forwardTeam = "";
                        return [4 /*yield*/, this.onForwardTeamChange()];
                    case 7:
                        _a.sent();
                        this.userIdReceive = "";
                        return [3 /*break*/, 8];
                    case 8:
                        this.submittedForward = false;
                        this.forwardRemark = "";
                        $("#forwardModal").modal('show');
                        return [3 /*break*/, 10];
                    case 9:
                        this.util.WarningDialog("กรุณาเลือกเฉพาะรายการที่มีสถานะเป็น New หรือ Inprogress เท่านั้น");
                        _a.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    NewCaseComponent.prototype.confirmForward = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.submittedForward = true;
                if (this.forwardTeam != null && this.forwardTeam.trim() != "" && this.forwardRemark != null && this.forwardRemark.trim() != "") {
                    this.form.controls["dpa_owningteamid"].setValue(this.forwardTeam);
                    this.form.controls["dpa_caseowner"].setValue(this.userIdReceive);
                    this.form.controls["dpa_assignby"].setValue(this.cookieData.userId);
                    this.form.controls["dpa_remark"].setValue(this.forwardRemark);
                    this.save(false, true);
                }
                return [2 /*return*/];
            });
        });
    };
    NewCaseComponent.prototype.save = function (close, closeForward) {
        if (close === void 0) { close = false; }
        if (closeForward === void 0) { closeForward = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var caseId_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!((this.isRemarkRequired && this.formControl["dpa_remark"].value.trim().length == 0) ||
                            (this.isResolvedRequired && this.formControl["dpa_resolution"].value.trim().length == 0))) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1:
                        if (!this.form.valid) return [3 /*break*/, 10];
                        //set team
                        if (!closeForward) {
                            if (this.myTeams != null && this.myTeams.length > 0) {
                                this.formControl["dpa_owningteamid"].setValue(this.myTeams[0].dpa_callcenterteamid);
                            }
                            else {
                                this.formControl["dpa_owningteamid"].setValue(null);
                            }
                        } //set team
                        this.util.ShowWaiting(true);
                        if (!this.isEditMode) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.updateCase()];
                    case 2:
                        if (!_a.sent()) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.updateContact()];
                    case 3:
                        if (_a.sent()) {
                            this.util.ShowWaiting(false);
                            this.checkIsSaveCloseCase();
                            if (closeForward) {
                                $("#forwardModal").modal('hide');
                                setTimeout(function () {
                                    $("#forwardSuccessModal").modal('show');
                                }, 800);
                            }
                            else if (close) {
                                window.close();
                            }
                            else {
                                this.checkIsSaveCloseCase();
                                this.isEditMode = true;
                                this.util.SuccessDialog("แก้ไขสำเร็จ");
                            }
                        }
                        else {
                            this.util.ErrorDialog("แก้ไขไม่สำเร็จ");
                            this.util.ShowWaiting(false);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        this.util.ErrorDialog("แก้ไขไม่สำเร็จ");
                        this.util.ShowWaiting(false);
                        _a.label = 5;
                    case 5: return [3 /*break*/, 10];
                    case 6:
                        if (!!this.isNewCaseForContactId) return [3 /*break*/, 8];
                        //this.form.controls["dpa_casechannelid"].setValue(this.dpa_casechannelid)
                        this.form.controls["callcenterflag"].setValue(true);
                        //this.form.controls["dpa_pdpa_flag"].setValue(true)
                        this.dpa_pdpa_flag = $('#ra1')[0].checked;
                        this.form.controls["dpa_pdpa_flag"].setValue(this.dpa_pdpa_flag);
                        return [4 /*yield*/, this.apiService.postCustom("crmservice", "contact", this.form.getRawValue()).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (this.util.isSuccessResponse(res)) {
                                        if (res.contactid != null && res.contactid != "" && res.incidentid != null && res.incidentid != "") {
                                            caseId_1 = res.incidentid;
                                            this.form.controls["contactid"].setValue(res.contactid);
                                            this.form.controls["incidentid"].setValue(res.incidentid);
                                            this.form.controls["customerid"].setValue(res.customerid);
                                        }
                                        else {
                                            caseId_1 = null;
                                        }
                                    }
                                    else {
                                        caseId_1 = null;
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 7:
                        _a.sent();
                        if (caseId_1 != null) {
                            this.guid = caseId_1;
                            if (this.dpa_pdpa_flag) {
                                $("#ra1")[0].checked = true;
                                $("#ra2")[0].checked = false;
                            }
                            else {
                                $("#ra1")[0].checked = false;
                                $("#ra2")[0].checked = true;
                            }
                            this.util.ShowWaiting(false);
                            if (closeForward) {
                                $("#forwardModal").modal('hide');
                                setTimeout(function () {
                                    $("#forwardSuccessModal").modal('show');
                                }, 800);
                            }
                            else if (close) {
                                window.close();
                            }
                            else {
                                this.checkIsSaveCloseCase();
                                this.isEditMode = true;
                                this.util.SuccessDialog("สร้าง Case สำเร็จ");
                                //$('#btnSuccessOK').on('click', function () {
                                //  window.location.reload();
                                //});
                            }
                        }
                        else {
                            if (closeForward) {
                                this.util.ErrorDialog("ส่งต่อ Case ไม่สำเร็จ");
                            }
                            else {
                                this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ");
                            }
                            this.util.ShowWaiting(false);
                        }
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, this.createCase(true).then(function (caseId) {
                            _this.form.controls["incidentid"].setValue(caseId);
                            if (caseId != null) {
                                _this.util.ShowWaiting(false);
                                if (closeForward) {
                                    $("#forwardModal").modal('hide');
                                    setTimeout(function () {
                                        $("#forwardSuccessModal").modal('show');
                                    }, 800);
                                }
                                else if (close) {
                                    window.close();
                                }
                                else {
                                    _this.checkIsSaveCloseCase();
                                    _this.util.SuccessDialog("สร้าง Case สำเร็จ");
                                    _this.isEditMode = true;
                                }
                            }
                            else {
                                if (closeForward) {
                                    _this.util.ErrorDialog("ส่งต่อ Case ไม่สำเร็จ");
                                }
                                else {
                                    _this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ");
                                }
                                _this.util.ShowWaiting(false);
                            }
                        })];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    NewCaseComponent.prototype.initViewMode = function (caseInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var channel, status, severiry, caseType, caseSubType, caseSubTypeDetail;
            return __generator(this, function (_a) {
                if (caseInfo != null && caseInfo.length > 0) {
                    this.mapDataToForm(caseInfo[0]);
                    channel = this.caseChannelList.filter(function (c) {
                        return c.dpa_name == caseInfo[0].dpa_casechannelidname;
                    });
                    status = this.caseStatusList.filter(function (c) {
                        return c.dpa_code == caseInfo[0].dpa_casestatuscode;
                    });
                    severiry = this.caseSeverityList.filter(function (c) {
                        return c.dpa_name == caseInfo[0].dpa_caseseverityidname;
                    });
                    caseType = this.caseTypeList.filter(function (c) {
                        return c.dpa_name == caseInfo[0].dpa_casetypeidname;
                    });
                    if (caseType != null && caseType.length > 0) {
                        this.caseSubTypeList = this.subTypeTmpList.filter(function (subType) { return subType.dpa_casetypeid === caseType[0].dpa_casetypeid; });
                    }
                    caseSubType = this.caseSubTypeList.filter(function (c) {
                        return c.dpa_name == caseInfo[0].dpa_casesubtypeidname;
                    });
                    if (caseSubType != null && caseSubType.length > 0) {
                        this.caseSubTypeDetailList = this.subTypeDetailTmpList.filter(function (s) { return s.dpa_casesubtypeid === caseSubType[0].dpa_casesubtypeid; });
                    }
                    caseSubTypeDetail = this.caseSubTypeDetailList.filter(function (c) {
                        return c.dpa_name == caseInfo[0].dpa_casesubtypedetailidname;
                    });
                    this.isShowAnswerLink = (caseInfo[0].dpa_casechannelidname != null && caseInfo[0].dpa_casechannelidname == "Social");
                    this.form.controls["firstname"].setValue(caseInfo[0]["firstname"]);
                    this.form.controls["lastname"].setValue(caseInfo[0]["lastname"]);
                    this.form.controls["telephone1"].setValue(caseInfo[0]["telephone1"]);
                    this.form.controls["dpa_otherphone"].setValue(caseInfo[0]["dpa_otherphone"]);
                    this.form.controls["emailaddress1"].setValue(caseInfo[0]["emailaddress1"]);
                    if (caseType != null && caseType.length > 0) {
                        this.form.controls["dpa_casetypeid"].setValue(caseType[0]["dpa_casetypeid"]);
                    }
                    if (caseSubType != null && caseSubType.length > 0) {
                        this.form.controls["dpa_casesubtypeid"].setValue(caseSubType[0]["dpa_casesubtypeid"]);
                    }
                    if (caseSubTypeDetail != null && caseSubTypeDetail.length > 0) {
                        this.form.controls["dpa_casesubtypedetailid"].setValue(caseSubTypeDetail[0]["dpa_casesubtypedetailid"]);
                    }
                    if (channel != null && channel.length > 0) {
                        this.form.controls["dpa_casechannelid"].setValue(channel[0]["dpa_casechannelid"]);
                    }
                    if (severiry != null && severiry.length > 0) {
                        this.form.controls["dpa_caseseverityid"].setValue(severiry[0]["dpa_caseseverityid"]);
                    }
                    if (status != null && status.length > 0) {
                        this.form.controls["dpa_casestatusid"].setValue(status[0]["dpa_casestatusid"]);
                        if (status[0]["dpa_code"] != null && (status[0]["dpa_code"] == "03" || status[0]["dpa_code"].toLowerCase() == "04")) {
                            this.isEndCase = true;
                            $("#form :input").prop("disabled", true);
                            $("#btnKm").prop("disabled", false);
                        }
                    }
                    this.form.controls["description"].setValue(caseInfo[0]["description"]);
                    this.form.controls["dpa_resolution"].setValue(caseInfo[0]["dpa_resolution"]);
                    this.form.controls["dpa_remark"].setValue(caseInfo[0]["dpa_remark"]);
                    this.createdon = caseInfo[0]["createdon"];
                    this.modifiedon = caseInfo[0]["modifiedon"];
                    this.form.controls["dpa_modifiedby"].setValue(this.cookieData.userId);
                    this.createBy = caseInfo[0]["dpa_createdbyname"];
                    this.modifiedBy = caseInfo[0]["dpa_modifiedbyname"];
                    this.dpa_pdpa_flag = caseInfo[0]["dpa_pdpa_flag"];
                    if (this.dpa_pdpa_flag) {
                        $("#ra1")[0].checked = true;
                        $("#ra2")[0].checked = false;
                    }
                    else {
                        $("#ra1")[0].checked = false;
                        $("#ra2")[0].checked = true;
                    }
                    this.form.controls["telephone1"].disable();
                    this.onCaseChannelChange();
                    if (caseInfo[0].dpa_casestatuscode != null && (caseInfo[0].dpa_caseowner != this.cookieData.dpa_name ||
                        caseInfo[0].dpa_casestatuscode == "04" ||
                        caseInfo[0].dpa_casestatuscode == "03")) {
                        this.isEndCase = true;
                        $("#form :input").prop("disabled", true);
                        $("#btnKm").prop("disabled", false);
                    }
                    else {
                        this.isEditMode = true;
                        this.form.controls["customerid"].setValue(caseInfo[0]["customerid"]);
                        this.form.controls["contactid"].setValue(caseInfo[0]["customerid"]);
                        this.form.controls["incidentid"].setValue(caseInfo[0]["incidentid"]);
                        this.form.controls["dpa_caseowner"].setValue(this.cookieData.userId);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    NewCaseComponent.prototype.initAddMode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var channel, status;
            return __generator(this, function (_a) {
                if (this.cookieData.incomingTelephoneNo != null && this.cookieData.incomingTelephoneNo != "") {
                    this.form.controls["telephone1"].setValue(this.cookieData.incomingTelephoneNo);
                    this.cookieData.incomingTelephoneNo = null;
                    localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData));
                }
                channel = this.caseChannelList.filter(function (ch) {
                    if (_this.isNewCaseForChatbot) {
                        return ch.dpa_name.replace(" ", "").toLowerCase() == "chatbot";
                    }
                    else {
                        return ch.dpa_name.replace(" ", "").toLowerCase() == "callcenter";
                    }
                });
                if (channel != null && channel.length > 0) {
                    this.dpa_casechannelid = channel[0].dpa_casechannelid;
                    this.form.controls["dpa_casechannelid"].setValue(channel[0].dpa_casechannelid);
                }
                status = this.caseStatusList.filter(function (ch) {
                    return ch.dpa_name.replace(" ", "").toLowerCase() == "new";
                });
                if (status != null && status.length > 0) {
                    this.form.controls["dpa_casestatusid"].setValue(status[0].dpa_casestatusid);
                }
                this.createdon = new Date();
                this.modifiedon = new Date();
                this.form.controls["dpa_createdby"].setValue(this.cookieData.userId);
                this.form.controls["dpa_modifiedby"].setValue(this.cookieData.userId);
                this.createBy = this.cookieData.dpa_name;
                this.modifiedBy = this.cookieData.dpa_name;
                this.form.controls["statusreason"].setValue(1);
                this.form.controls["dpa_caseowner"].setValue(this.cookieData.userId);
                return [2 /*return*/];
            });
        });
    };
    NewCaseComponent.prototype.initAddModeForContact = function (contact) {
        return __awaiter(this, void 0, void 0, function () {
            var channel, status;
            return __generator(this, function (_a) {
                this.form.controls["contactid"].setValue(contact["contactid"]);
                this.form.controls["customerid"].setValue(contact["contactid"]);
                this.form.controls["firstname"].setValue(contact["firstname"]);
                this.form.controls["lastname"].setValue(contact["lastname"]);
                this.form.controls["telephone1"].setValue(contact["telephone1"]);
                this.form.controls["dpa_otherphone"].setValue(contact["dpa_otherphone"]);
                this.form.controls["emailaddress1"].setValue(contact["emailaddress1"]);
                $(".contact-input").prop("disabled", true);
                channel = this.caseChannelList.filter(function (ch) {
                    return ch.dpa_name.replace(" ", "").toLowerCase() == "callcenter";
                });
                if (channel == null || channel.length > 0) {
                    this.form.controls["dpa_casechannelid"].setValue(channel[0].dpa_casechannelid);
                }
                status = this.caseStatusList.filter(function (ch) {
                    return ch.dpa_name.replace(" ", "").toLowerCase() == "new";
                });
                if (status == null || status.length > 0) {
                    this.form.controls["dpa_casestatusid"].setValue(status[0].dpa_casestatusid);
                }
                this.createdon = new Date();
                this.modifiedon = new Date();
                this.form.controls["dpa_createdby"].setValue(this.cookieData.userId);
                this.form.controls["dpa_modifiedby"].setValue(this.cookieData.userId);
                this.createBy = this.cookieData.dpa_name;
                this.modifiedBy = this.cookieData.dpa_name;
                this.form.controls["statusreason"].setValue(1);
                this.form.controls["dpa_caseowner"].setValue(this.cookieData.userId);
                this.util.ShowWaiting(false);
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(NewCaseComponent.prototype, "formControl", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewCaseComponent.prototype, "email", {
        get: function () {
            return this.form.value.emailaddress1.trim();
        },
        enumerable: true,
        configurable: true
    });
    NewCaseComponent.prototype.emailValidator = function (control) {
        if (control.value) {
            var matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
            return matches ? null : { 'invalidEmail': true };
        }
        else {
            return null;
        }
    };
    NewCaseComponent.prototype.closeWindow = function () {
        window.close();
    };
    NewCaseComponent.prototype.onForwardTeamChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.agentList.filter(function (a) {
                            return a.dpa_teamidlist.map(function (ag) { return ag.dpa_callcenterteamid; }).indexOf(_this.forwardTeam) > -1;
                        })];
                    case 1:
                        tmp = _a.sent();
                        this.userList = [];
                        tmp.forEach(function (a) {
                            if (_this.userList.indexOf(a) == -1 && a.dpa_customwebuserid != _this.cookieData.userId) {
                                _this.userList.push(a);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    NewCaseComponent.prototype.onCaseTypeChange = function () {
        var _this = this;
        this.caseSubTypeList = this.subTypeTmpList.filter(function (subType) { return subType.dpa_casetypeid === _this.form.get("dpa_casetypeid").value; });
        this.form.get("dpa_casesubtypeid").setValue("");
        this.onCaseSubTypeChange();
    };
    NewCaseComponent.prototype.onCaseSubTypeChange = function () {
        var _this = this;
        this.caseSubTypeDetailList = this.subTypeDetailTmpList.filter(function (s) { return s.dpa_casesubtypeid === _this.form.get("dpa_casesubtypeid").value; });
        this.form.get("dpa_casesubtypedetailid").setValue("");
    };
    NewCaseComponent.prototype.filterByType = function (type) {
        this.util.ShowWaiting(true);
        this.showingKBList = this.kmList.filter(function (kb) {
            if (type === kb.dpa_knowledgebasetype) {
                return true;
            }
        });
        this.util.ShowWaiting(false);
    };
    NewCaseComponent.prototype.filterKm = function () {
        var _this = this;
        this.util.ShowWaiting(true);
        this.kmCriteria = $("#kmCri").val();
        if (this.kmCriteria != null && this.kmCriteria.trim().length == 0) {
            this.showingKBList = [];
        }
        else {
            this.showingKBList = this.kmList.filter(function (kb) {
                if (kb.dpa_keyword != null && kb.dpa_keyword.includes(_this.kmCriteria)) {
                    return true;
                }
            });
        }
        this.util.ShowWaiting(false);
    };
    NewCaseComponent.prototype.onCaseStatusChange = function () {
        var _this = this;
        var status = this.caseStatusList.filter(function (c) {
            return c.dpa_casestatusid == _this.form.controls["dpa_casestatusid"].value;
        });
        if (status != null && status.length > 0) {
            if (status[0].dpa_code == "04") {
                this.isRemarkRequired = true;
            }
            else {
                this.isRemarkRequired = false;
            }
            if (status[0].dpa_code == "03") {
                this.isResolvedRequired = true;
            }
            else {
                this.isResolvedRequired = false;
            }
        }
    };
    NewCaseComponent.prototype.mapDataToForm = function (data) {
        var _this = this;
        Object.keys(data).forEach(function (key) {
            if (_this.form.controls[key]) {
                _this.form.controls[key].setValue(data[key]);
            }
            else {
                _this.form.addControl(key, new FormControl(data[key]));
            }
        });
    };
    NewCaseComponent.prototype.openKm = function () {
        var url = this.util.baseUrl() + "/mainmenu/knowledge/";
        window.open(url, '_blank');
    };
    NewCaseComponent.prototype.checkIsSaveCloseCase = function () {
        if (this.isRemarkRequired || this.isResolvedRequired) {
            this.isEndCase = true;
            $("#form :input").prop("disabled", true);
            $("#btnKm").prop("disabled", false);
        }
    };
    NewCaseComponent.prototype.closeForwardSuccess = function () {
        $("#forwardSuccessModal").modal('hide');
        setTimeout(function () {
            //this.ngOnInit()
            window.location.reload();
        }, 800);
    };
    NewCaseComponent.prototype.onCaseChannelChange = function () {
        var _this = this;
        if (this.form.controls["dpa_casechannelid"].value == null || this.form.controls["dpa_casechannelid"].value == "") {
            return;
        }
        var filtered = this.caseChannelList.filter(function (c) {
            return _this.form.controls["dpa_casechannelid"].value == c.dpa_casechannelid;
        });
        if (filtered != null && filtered.length > 0) {
            var tmpChannelb = filtered[0].dpa_name.replace(" ", "").toLowerCase();
            if (tmpChannelb != "callcenter") {
                this.form.controls["telephone1"].enable();
                this.form.get('telephone1').clearValidators();
                $(".lblTelephone").removeClass("required");
                this.form.controls['telephone1'].updateValueAndValidity();
            }
        }
    };
    return NewCaseComponent;
}());
export { NewCaseComponent };



// WEBPACK FOOTER //
// ./src/app/new-case/new-case.component.ts.pre-build-optimizer.js